@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;
@use '../../styling/buttons.scss' as *;

.ExpandableString {
  @extend %font-family-primary;

  overflow-wrap: break-word;
  white-space: pre-line;
  display: flex;
}

.isExpanded {
  align-items: end;
}
